import { render } from "./WorkingShift.vue?vue&type=template&id=dd5bf420"
import script from "./WorkingShift.vue?vue&type=script&lang=js"
export * from "./WorkingShift.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__